<template>
    <div>
        <rkm-table
            :items="dados"
            :fields="fields.tables.tipo"
            :filter="filter"
            sort-by="nomeFantasia"
        >
            <template slot="filters">
                <rkm-row>
                    <rkm-col class="flex-grow-1">
                        <rkm-form-input
                            placeholder="Digite para buscar"
                            v-model="filter"
                        >
                            <rkm-input-group-prepend slot="prepend">
                                <rkm-input-group-text>Buscar</rkm-input-group-text>
                            </rkm-input-group-prepend>
                        </rkm-form-input>
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-select
                            :options="data.form.tipoUnidade"
                            show-default-option
                            default-option-text="Selecione o tipo"
                            text-field="descricao"
                            value-field="id"
                            v-model="model.tipoUnidade"
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-0">
                        <rkm-button
                            :disabled="!filter && !model.tipoUnidade"
                            @click="handleClearFilter"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-slot:cell(actions)="{ index, item }">
                <rkm-button
                    @click="$refs.Modal.open(index, item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="handleDestroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

// Enums.
import tipoUnidade from '@/enums/exame-laboratorial/tipoUnidade'

export default {
    components: { Modal },
    computed: {
        fields() {

            return {
                tables: {
                    tipo: [
                        { key: 'nomeFantasia', label: 'Unidade', sortable: true },
                        { key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true },
                        { key: 'tipo', label: 'Tipo', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min' },
                    ],
                }
            }
        },
        dados(){

            const tipoUnidade = this.model.tipoUnidade

            if (tipoUnidade != null) {

                if (tipoUnidade == this.enums.tipoUnidade.COLETA) {

                    return this.items.filter(i => {return i.tipo == 'Coleta'})

                } else if (tipoUnidade == this.enums.tipoUnidade.LABORATORIO) {

                    return this.items.filter(i => {return i.tipo == 'Laboratório'})

                } else if (tipoUnidade == this.enums.tipoUnidade.AMBOS) {

                    return this.items.filter(i => {return i.tipo == 'Coleta / Laboratório'})
                }
            }

            return this.items
        },
    },
    data: () => ({
        items: [],
        model:{
            tipoUnidade: null,
        },
        filter: null,
        enums: {
            tipoUnidade
        },
    }),
    methods: {
        handleDestroy(item) {

            if (item.laboratorio) {

                const hasUnidade = this.data.model.cotasLaboratorio
                    .find(cc => cc.unidadeId === item.unidadeId && cc.infraestruturaId === item.infraestruturaId)

                if (hasUnidade) {

                    this.showValidationNotification(`Não é possível excluir a unidade <strong>${ item.nomeFantasia }</strong> e o
                    local de atendimento <strong>${ item.infraestruturaNome }</strong>, pois já possui cotas.`)

                    return false
                }

            }

            const objIndex = this.data.model.unidades.findIndex((obj => obj.id == item.id));

            const destroy = async () => this.data.model.unidades.splice(objIndex, 1)

            this.showDeleteConfirmation('Deseja realmente excluir a unidade?', destroy)
        },
        handleClearFilter() {
            this.filter = null
            this.model.tipoUnidade = null
        },
    },
    props: {
        data: { type: Object, required: true },
    },
    watch: {
        'data.model.unidades' (unidades) {
            this.items = unidades.map(unidade => {

                let tipo = ''

                if (unidade.unidadeColeta && unidade.laboratorio) {
                    tipo = 'Coleta / Laboratório'
                }
                else if (unidade.unidadeColeta) {
                    tipo = 'Coleta'
                }
                else if (unidade.laboratorio) {
                    tipo = 'Laboratório'
                }

                return {
                    id: unidade.id,
                    nomeFantasia: unidade.nomeFantasia,
                    infraestruturaNome: unidade.infraestruturaNome,
                    unidadeId: unidade.unidadeId,
                    infraestruturaId: unidade.infraestruturaId,
                    tipo: tipo,
                    laboratorio: unidade.laboratorio
                }
            })
        }
    }
}
</script>